export default __webpack_public_path__ + "static/media/edit_icon.3ff2b8d2.svg";